import * as types from './actionsTypes';
import { NavigateFunction } from 'react-router';

export type SaveUpdateActionType = {
  type: string;
  navigate: NavigateFunction;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  id: number;
  headers: any;
};

export const saveUpdateAction = (
  navigate: NavigateFunction,
  firstName: string,
  lastName: string,
  phoneNumber: string,
  email: string,
  id: number,
  headers: any
) => ({
  type: types.UPDATE_CUSTOMER,
  navigate,
  firstName,
  lastName,
  phoneNumber,
  email,
  id,
  headers,
});
